module.exports = __webpack_public_path__ + "static/main2_pc-e9cccede00b0095655221cf9f5ecc0a0.jpg";